import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots, unref as _unref } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  id: "add-room-item-modal-label"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title",
  id: "add-room-item-modal-label"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Prompt", -1)
const _hoisted_12 = { class: "col-sm-9" }
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Type", -1)
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Options", -1)
const _hoisted_18 = { class: "col-sm-3" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "form-group row"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Link", -1)
const _hoisted_23 = { class: "col-sm-9" }
const _hoisted_24 = {
  key: 2,
  class: "form-group row"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Conditional", -1)
const _hoisted_26 = { class: "col-sm-9" }
const _hoisted_27 = {
  key: 3,
  class: "form-group row"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Link condition value", -1)
const _hoisted_29 = { class: "col-sm-9" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Flag", -1)
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Flag value", -1)
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = { class: "form-group row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Required", -1)
const _hoisted_40 = { class: "col-sm-6" }
const _hoisted_41 = { class: "form-group row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Photo", -1)
const _hoisted_43 = { class: "col-sm-6" }
const _hoisted_44 = { class: "form-group row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Notes", -1)
const _hoisted_46 = { class: "col-sm-6" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "FixFlo category", -1)
const _hoisted_50 = { class: "col-sm-9" }
const _hoisted_51 = { class: "form-group row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "FixFlo sub-category", -1)
const _hoisted_53 = { class: "col-sm-9" }
const _hoisted_54 = { class: "modal-footer" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]

import $ from 'jquery';
import { computed, ref, inject, nextTick } from 'vue';
import { snakeCase } from "lodash";
import { useStore } from 'vuex';
import { Compliancequestion, QuestionWrapper, SelectOption, QuestionOption } from "@/models";
import ContentEditable from "@/components/ContentEditable.vue";
import { CustomerDictionaryState } from '@/store/customerdictionary/types';
import { useToast } from "vue-toastification";
import { DxSwitch } from 'devextreme-vue/switch';
import fixflocategories from '@/store/dictionary/json/fixflocategories.json';

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'MidTermQuestionModal',
  props: {
    id: {},
    operation: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// Vuex store
const store = useStore();
const compliancelist = computed((): Compliancequestion[] => store.getters['customerdictionary/compliancelist'] as Compliancequestion[]);
const questionwrapper = computed(() => store.getters['customerdictionary/questionwrapper'] as QuestionWrapper);
const selectedquestion = computed(() => store.getters['customerdictionary/selectedquestion'] as Compliancequestion);

const addToComplianceList = async (question: {}) => {
  await store.dispatch('customerdictionary/addToComplianceList', question);
};

const setCustomerdictionaryDeep = async (payload: { path: string; data: any; }) => {
  await store.dispatch('customerdictionary/setCustomerdictionaryDeep', payload);
};
const actProperty: any = inject('actProperty');
const toasted = useToast();
const options = ref(null);

// Computed properties for options
const typeOptions = computed(() => [
  { name: "Select List", slug: "select" },
  { name: "Text", slug: "text" },
  { name: "Text Area", slug: "textarea" },
  { name: "Heading", slug: "heading" },
  { name: "Sub Heading", slug: "subheading" },
]);

const questionoptions = computed(() => questionwrapper.value.options);
const linkOptions = computed(() => {
  let optionList: SelectOption[] = [];
  if (compliancelist.value) {
    optionList = compliancelist.value
      .filter((question) => question != selectedquestion.value)
      .map((question) => ({ slug: question.slug, name: question.prompt }));
  }
  return optionList;
});

const clearLinkedItem = () => {
  questionwrapper.value.link = new SelectOption();
};

const insertOption = (optionIndex: number, $event?: any) => {
  let insertAtIndex = 0;

  if (typeof optionIndex === "number") {
    insertAtIndex = optionIndex + 1;
  }

  const option = new QuestionOption({});

  let cursorPos = -1;
  let selection: Selection | null = window.getSelection();
  if (selection) {
    cursorPos = selection.anchorOffset;
  }

  if (questionwrapper.value.options.length > optionIndex) {
    let currentOption = questionwrapper.value.options[optionIndex];
    let currentOptionValue = $event.currentTarget.innerText;
    if (
      currentOptionValue &&
      cursorPos >= 0 &&
      currentOptionValue.length > cursorPos
    ) {
      let contentsBeforeCursor = currentOptionValue.substring(0, cursorPos);
      let contentsAfterCursor = currentOptionValue.substring(
        cursorPos,
        currentOptionValue.length
      );
      currentOption.value = contentsBeforeCursor;
      option.value = contentsAfterCursor;
      const found = (options.value as any).find(
        (x: any) => x.$attrs["data-uuid"] === currentOption._uuid
      );
      if (found) {
        found.$el.innerHTML = contentsBeforeCursor;
      }
    }
  }

  questionwrapper.value.options.splice(insertAtIndex, 0, option);
  nextTick(() => {
    const found = (options.value as any).find((x: any) => x.$attrs["data-uuid"] === option._uuid);
    if (found) {
      setCursorAtEnd(found.$el);
    }
  });
};

const setCursorAtEnd = (el: any) => {
  if (!el) {
    return;
  }

  const range = document.createRange();
  const selection = window.getSelection();
  if (selection) {
    selection.removeAllRanges();
  }

  if (el.firstChild) {
    range.setStart(el.firstChild, el.firstChild.length);
  } else {
    range.setStart(el, 0);
  }
  range.collapse(true);
  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range);
  }
};

const updateOption = (optionIndex: number, $event: any) => {
  questionwrapper.value.options[optionIndex].value = $event;
}

const deleteOption = (optionIndex: number) => {
  questionwrapper.value.options.splice(optionIndex, 1);
  const refs = (options as any);
  if (refs.length) {
    if (optionIndex > 0) {
      setCursorAtEnd(refs[optionIndex - 1].$el);
    } else {
      setCursorAtEnd(refs[0].$el);
    }
  }
}

const fixfloCategoryForQuestion = computed({
  get: () => {
    return questionwrapper.value.fixflocategory;
  },
  set:(val: string) => {
    questionwrapper.value.fixflocategory = val;
    questionwrapper.value.fixflosubcategory = '';
  }
});

const fixfloSubCategoryForQuestion = computed({
  get: () => {
    return questionwrapper.value.fixflosubcategory;
  },
  set:(val: string) => {
    questionwrapper.value.fixflosubcategory = val;
  }
});

const fixfloItemCategoryOption = computed(() => {
  return fixflocategories.map((c: any) => c.name).sort();
});
const fixfloSubCategoryOption = computed(() => {
  const index = fixflocategories.findIndex((c: any) => c.name === fixfloCategoryForQuestion.value);
  var list: string[] = [];
  if(index >= 0) {
    list = fixflocategories[index].subcategories;
  }
  return list.sort();
});

const canAdd = (): boolean => {
  let result = true;

  const qw = questionwrapper.value;

  if (!qw.prompt) result = false;
  if (!qw.type.slug) result = false;
  if (qw.type.slug === "select" && !qw.options) result = false;
  if (qw.conditional && !qw.linkconditionvalue) result = false;
  if (qw.flag && !qw.flagvalue) result = false;

  return result;
};

const add = async () => {
  let newQuestion = new Compliancequestion();
  newQuestion.slug = snakeCase(questionwrapper.value.prompt);
  newQuestion.prompt = questionwrapper.value.prompt;
  newQuestion.questionType = questionwrapper.value.type.slug;
  newQuestion.optionList = questionwrapper.value.options.map(option => option.value);
  newQuestion.link = questionwrapper.value.link.slug;
  newQuestion.conditional = questionwrapper.value.conditional;
  newQuestion.linkconditionvalue = questionwrapper.value.linkconditionvalue;
  newQuestion.flag = questionwrapper.value.flag;
  newQuestion.flagvalue = questionwrapper.value.flagvalue;
  newQuestion.required = questionwrapper.value.required;
  newQuestion.photo = questionwrapper.value.photo;
  newQuestion.notes = questionwrapper.value.notes;
  newQuestion.fixflocategory = questionwrapper.value.fixflocategory;
  newQuestion.fixflosubcategory = questionwrapper.value.fixflosubcategory;
  addToComplianceList(newQuestion)
    .then(() => toasted.success(`Added "${newQuestion.prompt}"`))
    .then(() => reset())
    .catch((err: any) => {
      actProperty.displayError(err);
    });
  hide();
};

const midTermQuestionModalEdit = ref(null);
const save = async () => {
  if (!selectedquestion.value.slug)
    selectedquestion.value.slug = snakeCase(questionwrapper.value.prompt);
  selectedquestion.value.prompt = questionwrapper.value.prompt;
  selectedquestion.value.questionType = questionwrapper.value.type.slug;
  selectedquestion.value.optionList = questionwrapper.value.options.map(
    (option) => option.value
  );
  selectedquestion.value.link = questionwrapper.value.link.slug;
  selectedquestion.value.conditional = questionwrapper.value.conditional;
  selectedquestion.value.linkconditionvalue =
    questionwrapper.value.linkconditionvalue;
  selectedquestion.value.flag = questionwrapper.value.flag;
  selectedquestion.value.flagvalue = questionwrapper.value.flagvalue;
  selectedquestion.value.required = questionwrapper.value.required;
  selectedquestion.value.photo = questionwrapper.value.photo;
  selectedquestion.value.notes = questionwrapper.value.notes;
  selectedquestion.value.fixflocategory = questionwrapper.value.fixflocategory;
  selectedquestion.value.fixflosubcategory = questionwrapper.value.fixflosubcategory;

  let index = compliancelist.value.findIndex(
    (q) => q.slug == selectedquestion.value.slug
  );
  if (index >= 0) {
    setCustomerdictionaryDeep({
      path: `compliance_list[${index}]`,
      data: selectedquestion.value,
    })
      .then(() =>
        toasted.warning(`Locally saved "${selectedquestion.value.prompt}. Please remember to press final Save"`)
      )
      .then(() => reset())
      .catch((err: any) => {
        actProperty.displayError(err);
      });
  }

  hide();
};

const reset = () => {
  questionwrapper.value.slug = "";
  questionwrapper.value.prompt = "";
  questionwrapper.value.type = new SelectOption();
  // ... reset other properties ...
};
const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};
__expose({ add, show, hide });


return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`midterm-question-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, " New Question "))
            : (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(questionwrapper.value.prompt), 1)),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((questionwrapper.value.prompt) = $event))
                }, null, 512), [
                  [_vModelText, questionwrapper.value.prompt]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_multiselect, {
                  modelValue: questionwrapper.value.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((questionwrapper.value.type) = $event)),
                  "track-by": "slug",
                  label: "name",
                  options: typeOptions.value
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            (questionwrapper.value.type && questionwrapper.value.type.slug === 'select'
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    (!questionwrapper.value.options.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (insertOption(0, 0))),
                            class: "btn btn-sm btn-outline-secondary"
                          }, [
                            _hoisted_20,
                            _createTextVNode(" Option ")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionoptions.value, (option, $optionIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: option.slug
                      }, [
                        _createVNode(ContentEditable, {
                          ref_for: true,
                          ref_key: "options",
                          ref: options,
                          content: option.value,
                          "data-uuid": option._uuid,
                          onInsert: ($event: any) => (insertOption($optionIndex, $event)),
                          onUpdate: ($event: any) => (updateOption($optionIndex, $event)),
                          onDelete: ($event: any) => (deleteOption($optionIndex))
                        }, null, 8, ["content", "data-uuid", "onInsert", "onUpdate", "onDelete"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (linkOptions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_multiselect, {
                      modelValue: questionwrapper.value.link,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((questionwrapper.value.link) = $event)),
                      "track-by": "slug",
                      label: "name",
                      "allow-empty": true,
                      options: linkOptions.value
                    }, _createSlots({ _: 2 }, [
                      (linkOptions.value.length)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (clearLinkedItem()), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Linked Item"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (linkOptions.value && questionwrapper.value.link.slug)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: questionwrapper.value.conditional,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((questionwrapper.value.conditional) = $event)),
                      onValueChanged: _cache[7] || (_cache[7] = ($event: any) => (setCustomerdictionaryDeep({ path: 'questionwrapper.conditional', data: $event.value })))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (questionwrapper.value.link.slug && questionwrapper.value.conditional)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((questionwrapper.value.linkconditionvalue) = $event))
                    }, null, 512), [
                      [_vModelText, questionwrapper.value.linkconditionvalue]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: questionwrapper.value.flag,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((questionwrapper.value.flag) = $event)),
                      onValueChanged: _cache[10] || (_cache[10] = ($event: any) => (setCustomerdictionaryDeep({ path: 'questionwrapper.flag', data: $event.value })))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (questionwrapper.value.flag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((questionwrapper.value.flagvalue) = $event))
                        }, null, 512), [
                          [_vModelText, questionwrapper.value.flagvalue]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: questionwrapper.value.required,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((questionwrapper.value.required) = $event)),
                      onValueChanged: _cache[13] || (_cache[13] = ($event: any) => (setCustomerdictionaryDeep({ path: 'questionwrapper.required', data: $event.value })))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: questionwrapper.value.photo,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((questionwrapper.value.photo) = $event)),
                      onValueChanged: _cache[15] || (_cache[15] = ($event: any) => (setCustomerdictionaryDeep({ path: 'questionwrapper.photo', data: $event.value })))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: questionwrapper.value.notes,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((questionwrapper.value.notes) = $event)),
                      onValueChanged: _cache[17] || (_cache[17] = ($event: any) => (setCustomerdictionaryDeep({ path: 'questionwrapper.notes', data: $event.value })))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: fixfloCategoryForQuestion.value,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((fixfloCategoryForQuestion).value = $event)),
                      options: fixfloItemCategoryOption.value
                    }, _createSlots({ _: 2 }, [
                      (fixfloCategoryForQuestion.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (fixfloCategoryForQuestion.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Job Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: fixfloSubCategoryForQuestion.value,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((fixfloSubCategoryForQuestion).value = $event)),
                      options: fixfloSubCategoryOption.value
                    }, _createSlots({ _: 2 }, [
                      (fixfloSubCategoryForQuestion.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (fixfloSubCategoryForQuestion.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Job Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-bs-dismiss": "modal",
            onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Back "),
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (add()), ["prevent"])),
                disabled: !canAdd()
              }, " Add question ", 8, _hoisted_55))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (save()), ["prevent"])),
                disabled: !canAdd()
              }, " Ok ", 8, _hoisted_56))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})